import { handleShowMessageNotification } from '../common/handleShowMessageNotification';

export const showMessageNotification = ({ data: { message, templateId, closeClient } }) =>
    handleShowMessageNotification({ message, templateId, closeClient });
